import * as React from "react";

export const SuccessIcon = (props: any) => (
  <svg
    width={35}
    height={26}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.257 19.365 31.641.979l2.83 2.828-21.214 21.214L.529 12.293l2.828-2.828 9.9 9.9Z"
      fill="#F2F4F8"
    />
  </svg>
);
